import { RootState } from '../store';

export const selectCurrentArticleIndex = (state: RootState): number => {
  return state.consignmentSwitcher?.currentArticleIndex || 0;
};
